export default [
	{
		error: 'invalid_grant',
		header: 'Login failed',
		message: 'The username or password is invalid.',
	},
	{
		error: 'invalid_subscription',
		header: 'Login failed',
		message: 'A different subscription is required for your login.',
		code: 1000,
	},
	{
		error: 'invalid_subscription',
		header: '',
		message: 'The requested module is not part of your subscription.',
		code: 2000,
	},
	{
		error: 'invalid_subscription',
		header: '',
		message:
			'The requested module requires HausPerfekt version 14.X or higher.',
		messageShort: 'HausPerfekt version 14.X or higher is required',
		code: 2001,
	},
	{
		error: 'invalid_subscription',
		header: '',
		message: 'The requested feature is not included in your subscription.',
		code: 3000,
	},
	{
		error: 'invalid_subscription',
		header: '',
		message:
			"Due to a change in your provider's subscription model, you will be logged out.",
		code: 3001,
	},
	{
		error: 'no database',
		header: 'No permission',
		message:
			'Your login credentials are correct, but no access permissions exist.',
	},
	{
		error: 'no persons',
		header: 'No permission',
		message:
			'Your login credentials are correct, but no person exists for your user account.',
	},
	{
		error: 'team member deactivated',
		header: 'Access deactivated',
		message:
			'Your access has been deactivated. Please contact your property management.',
	},
	{
		error: 'cannot deactivate self',
		header: 'Not possible',
		message:
			'You cannot deactivate your own access. Please ask another team member or your property management to do it.',
	},
	{
		error: 'cannot change own permissions',
		header: 'Not possible',
		message:
			'You cannot change your own permissions. Please contact your property management.',
	},
	{
		error: 'retry-after',
		header: '',
		message: 'Too many failed attempts. Please try again later.',
	},
	{
		error: 'The selected email is invalid.',
		header: '',
		message: 'No account exists for the provided email address.',
	},
	{
		error: 'The new password confirmation does not match.',
		header: '',
		message: 'The new password does not match the confirmation.',
	},
	{
		error: 'model_not_found',
		header: '',
		message: 'The requested information could not be loaded.',
	},
]
